import { FC } from "react";
import { Spinner } from "../Spinner";
import { AccessibilityProps } from "../../AccessibilityProps";
import classNames from "classnames";

import styles from "./styles.module.css";

/** The `LoadingOverlay` component properties. */
interface LoadingOverlayProps extends Pick<AccessibilityProps, "aria-busy"> {
}

/** The loading overlay component. */
export const LoadingOverlay: FC<LoadingOverlayProps> = (props) => {
  const { "aria-busy": ariaBusy } = props;
  return (
    <div className={classNames(styles.LoadingOverlay, "loading-overlay")}>
      <Spinner size="large" aria-busy={ariaBusy} />
    </div>
  );
};
